import { Component, OnInit } from '@angular/core';
import { Output, EventEmitter, Input } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { UserModel } from 'src/app/models/user.model';
import { UserService } from 'src/app/services/user.service';
import { MessageService, ConfirmationService } from 'primeng/api';
import { ErrorPopUpModel } from '../../models/errorpopup.model';
import { UploadFile, UploaderOptions, UploadInput, UploadOutput, humanizeBytes, UploadStatus } from 'ngx-uploader';
import { severitymessage, SchedulesComponentmessage, FunctionalityNames, LanguageConstants } from '../../shared-components/constant';
import { environment } from 'src/environments/environment';
import { CoverIndexService } from 'src/app/services/coverindex.service';
import { WebJobQueueModel } from 'src/app/models/webJobQueue.model';
import { WebJobQueueService } from 'src/app/services/webjobqueue.service';
//import { debug } from 'util';
import { InfraService } from 'src/app/services/infra.service';
import { AuditingService } from 'src/app/services/auditing.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
@Component({
  standalone: false,
  selector: 'app-popupconfirmdataTab',
  templateUrl: './popupconfirmdataTab.component.html',
  styleUrls: ['./popupconfirmdataTab.component.css']
})
export class PopupconfirmdataTabComponent implements OnInit {
  options: UploaderOptions;
  errorModel: ErrorPopUpModel = new ErrorPopUpModel();
  loadspinner = false;
  isFileFormatCorrect = false;
  uploadInput: EventEmitter<UploadInput>;
  sourceFiles: UploadFile[];
  humanizeBytes: Function;
  databook: any;
  dragOver: boolean;
  private loggedInUserData: UserModel[];
  downloadErrorLogConfigUrl: string;
  engagementId = +this.route.snapshot.paramMap.get('id');
  configUrl: string;
  dataTabconfigUrl: string;
  timeOutHandler: NodeJS.Timer;
  isTimeIntervalInProgress = false;
  webJobQueueId: number;
  private loggedInUserId: number;
  previousStep: string;
  langCode: string;
  currLangTranslation: any;
  constructor(private infraService: InfraService, private route: ActivatedRoute, private router: Router, private http: HttpClient, private userService: UserService,
    private coverIndexService: CoverIndexService, private messageService: MessageService
    , private confirmationService: ConfirmationService, private webJobQueueService: WebJobQueueService,
    private auditService: AuditingService, private translateService: TranslateService) {

    this.loggedInUserId = + localStorage.getItem('loggedInUserId');
    this.infraService.infraDetails$.subscribe(data => {
      this.configUrl = data.WebEndPoint2 + 'databook/AddUploadedDatabookToQueue/' + this.engagementId;
      this.dataTabconfigUrl = data.WebEndPoint2 + 'databook/AddUploadedDatabookTemplateToQueue/' + this.engagementId;
      this.downloadErrorLogConfigUrl = data.WebEndPoint1 + 'filedownload/databookerrorlog/' + this.engagementId + '/' +
        this.loggedInUserId;
    });

    this.userService.cast.subscribe((userData: UserModel) => {
      if (userData !== undefined) {

        this.loggedInUserData = [];
        this.loggedInUserData.push(userData);
      }
    });

    this.options = {
      concurrency: 1, allowedContentTypes: [
        'application/vnd.ms-excel.sheet.macroEnabled.12',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
    };
    this.sourceFiles = [];
    this.uploadInput = new EventEmitter<UploadInput>(); // input events, we use this to emit data to ngx-uploader
    this.humanizeBytes = humanizeBytes;
  }


  @Input() displaydataTab = false;
  @Output() selecteddisplayevent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() closeEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() okEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() updateDataTabEvent: EventEmitter<boolean> = new EventEmitter<boolean>();



  ngOnInit() {
    this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
    this.currLangTranslation = this.translateService.translations[this.langCode];

    this.previousStep = this.currLangTranslation.actionButtons.previousStep;
    this.translateService.onLangChange.subscribe((langEvent: LangChangeEvent) => {
      this.currLangTranslation = langEvent.translations;
      this.previousStep = this.currLangTranslation.actionButtons.previousStep;
    });
  }
  ClosePopup() {
    // p-dialog clears `displaydataTab` through its [(visible)] binding before it
    // emits onHide, so guarding on it here would swallow the event and leave the
    // parent's flag stuck at true, which blocks the next input write.
    this.displaydataTab = false;
    this.closeEvent.emit(this.displaydataTab);
  }
  OkPopupclick() {
    this.displaydataTab = false;
    this.okEvent.emit(this.displaydataTab);
  }

  onUploadOutputData(output: UploadOutput, fileInput: any, databookType: number): void {
    if (output.file) {
      if (output.file.type === 'application/vnd.ms-excel.sheet.macroEnabled.12' || output.file.type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        this.isFileFormatCorrect = true;
      } else {
        this.isFileFormatCorrect = false;
      }
    }

    if (this.isFileFormatCorrect === true) {
      if (output.type === 'allAddedToQueue') { // when all files added in queue
        this.uploadDatabook(this.sourceFiles[0], fileInput, databookType);

      } else if (output.type === 'addedToQueue' && typeof output.file !== 'undefined') { // add file to array when added

        this.sourceFiles.push(output.file);

      } else if (output.type === 'uploading' && typeof output.file !== 'undefined') {
        // update current data in files array for uploading file
        //  this.loadspinner = true;
        const index = this.sourceFiles.findIndex(file => typeof output.file !== 'undefined' && file.id === output.file.id);
        this.sourceFiles[index] = output.file;

      } else if (output.type === 'done' && typeof output.file !== 'undefined') {
        this.handleUploadResponse(output.file, fileInput);
      } else if (output.type === 'rejected' && typeof output.file !== 'undefined') {
        this.loadspinner = false;

        this.errorModel.confirmIsDisplay = true;
        this.errorModel.displayMessage = this.currLangTranslation.uploadSourcefilemessage.errorMessage.FormateError;

        // Replace with Notification service
        // this.messageService.add({
        //   key: this.currLangTranslation.severitymessage.key, severity: this.currLangTranslation.severitymessage.error,
        //   summary: this.currLangTranslation.severitymessage.notification, detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
        // });
      } else if (output.type === 'removed') {
        this.loadspinner = false;
        // remove file from array when removed
        this.sourceFiles = this.sourceFiles.filter((file: UploadFile) => file !== output.file);
      } else if (output.type === 'dragOver') {
        this.dragOver = true;
      } else if (output.type === 'dragOut') {
        this.dragOver = false;
      } else if (output.type === 'drop') {
        this.dragOver = false;
      }
    } else if (this.isFileFormatCorrect === false) {
      this.loadspinner = false;
      this.isFileFormatCorrect = null;
      fileInput.value = '';
      this.errorModel.confirmIsDisplay = true;
      this.errorModel.displayMessage = this.currLangTranslation.uploadSourcefilemessage.errorMessage.FormateError;
    }
  }

  private uploadDatabook(file: UploadFile, fileInput: any, databookType: number): void {
    if (!file?.nativeFile) {
      this.loadspinner = false;
      return;
    }

    const formData = new FormData();
    formData.append('file', file.nativeFile, file.name);
    this.loadspinner = true;

    this.http.post(
      databookType === 1 ? this.configUrl : this.dataTabconfigUrl,
      formData,
      { observe: 'events', reportProgress: true }
    ).subscribe({
      next: event => {
        if (event.type === HttpEventType.UploadProgress && event.total) {
          file.progress = {
            status: UploadStatus.Uploading,
            data: {
              percentage: Math.round(event.loaded * 100 / event.total),
              speed: 0,
              speedHuman: '',
              startTime: null,
              endTime: null,
              eta: null,
              etaHuman: null
            }
          };
        } else if (event.type === HttpEventType.Response) {
          file.responseStatus = event.status;
          file.response = event.body;
          this.handleUploadResponse(file, fileInput);
        }
      },
      error: (error: HttpErrorResponse) => {
        file.responseStatus = error.status;
        file.response = error.error;
        this.handleUploadResponse(file, fileInput);
      }
    });
  }

  private handleUploadResponse(file: UploadFile, fileInput: any): void {
    this.loadspinner = true;

    if (file.response?.message === 'Invalid File Format') {
      this.loadspinner = false;
      fileInput.value = '';
      this.errorModel.confirmIsDisplay = true;
      this.errorModel.displayMessage =
        this.currLangTranslation.uploadSourcefilemessage.errorMessage.FormateError;
      this.sourceFiles = [];
      return;
    }

    const uploadResponse = file.response;
    this.webJobQueueId = uploadResponse?.id ?? uploadResponse?.Id;
    if (file.responseStatus >= 200 && file.responseStatus < 300) {
      this.auditService.addAudit(this.engagementId, FunctionalityNames.UploadDatabook).subscribe();
      this.displaydataTab = false;
      this.closeEvent.emit(this.displaydataTab);
      this.confirmationService.confirm({
        message: this.currLangTranslation.schedulesComponentmessage.UploadWarning.message,
        header: this.currLangTranslation.labels.confirmation,
        acceptLabel: this.currLangTranslation.actionButtons.yes,
        rejectLabel: this.currLangTranslation.actionButtons.no,
        accept: () => {
          this.checkDatabookUploadProcessed();
        },
        reject: () => {
          this.loadspinner = false;
          if (this.displaydataTab) {
            this.displaydataTab = false;
            this.closeEvent.emit(this.displaydataTab);
          }
        }
      });
    } else if (file.responseStatus === 400) {
      this.errorModel.confirmIsDisplay = true;
      this.errorModel.displayMessage =
        file.response?.message ||
        this.currLangTranslation.severitymessage.somethingwrong;
      this.loadspinner = false;
    } else {
      this.messageService.add({
        key: this.currLangTranslation.severitymessage.key,
        severity: severitymessage.error,
        summary: this.currLangTranslation.severitymessage.notification,
        detail: this.currLangTranslation.severitymessage.somethingwrong,
        sticky: true,
        closable: true
      });
      this.loadspinner = false;
    }

    this.sourceFiles = [];
    fileInput.value = '';
  }

  confirmdisplay = false;
  closeEventworkallocation($event) {

    this.confirmdisplay = $event;
  }



  private checkDatabookUploadProcessed() {
    this.webJobQueueService.getWebJobQueue(this.webJobQueueId).subscribe((resp: WebJobQueueModel) => {
      if (resp) {
        const queueResponse = resp as any;
        const isQueued = queueResponse.isQueued ?? queueResponse.IsQueued;
        const isError = queueResponse.isError ?? queueResponse.IsError;
        const responseText = queueResponse.responseText ?? queueResponse.ResponseText ?? '';
        if (!isQueued) {
          this.isTimeIntervalInProgress = false;
          clearInterval(this.timeOutHandler);
          if (isError) {
            this.loadspinner = false;
            if (responseText === '') {
              this.messageService.add({
                key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error,
                summary: this.currLangTranslation.severitymessage.notification,
                detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
              });
            } else {
              this.errorModel.confirmIsDisplay = true;
              this.errorModel.displayMessage = responseText;
            }
          } else {

            this.loadspinner = false;
            this.displaydataTab = false;
            this.ClosePopup();
            this.messageService.add({
              key: this.currLangTranslation.severitymessage.key, severity: severitymessage.success
              , summary: this.currLangTranslation.severitymessage.notification, detail: this.currLangTranslation.severitymessage.UploadDatabook, sticky: true, closable: true
            });
            this.updateDataTabEvent.emit(this.displaydataTab);
          }
        } else {
          if (!this.isTimeIntervalInProgress) {
            this.timeOutHandler = setInterval(() => {
              this.isTimeIntervalInProgress = true;
              this.loadspinner = true;
              this.checkDatabookUploadProcessed();
            }, environment.webjobTimer);
          }
        }
      } else {
        if (!this.isTimeIntervalInProgress) {
          this.timeOutHandler = setInterval(() => {
            this.isTimeIntervalInProgress = true;
            this.loadspinner = true;
            this.checkDatabookUploadProcessed();
          }, environment.webjobTimer);
        }
      }
    }, err => {
      this.loadspinner = false;
      this.isTimeIntervalInProgress = false;
      clearInterval(this.timeOutHandler);
      this.messageService.add({
        key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error,
        summary: this.currLangTranslation.severitymessage.notification,
        detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
      });
    });
  }
}
